import intl from 'react-intl-universal'

function websked($http, $q, storyService, $fn) {
  let oldStatus

  const wskErr = (reason) => {
    // TODO better logging
    console.log('Error fetching from websked', reason)
    return reason
  }

  const promiseWebsked = (path) => {
    const req = {
      method: 'GET',
      // url: `/websked/api-fake-websked-being-down/${path}`,
      url: `/websked/api/${path}`,
      timeout: 100000,
    }

    return $http(req).then((response) => {
      return response
    }, wskErr)
  }

  this.getWebskedStatus = () => {
    return promiseWebsked('statuses/workflow').then((response) => {
      if (response.status === 403) {
        return $q.reject(response)
      } else if (!response || !Array.isArray(response.data)) {
        return $q.reject('No workflow statuses were returned from websked')
      } else {
        return response
      }
    })
  }

  this.initializeOldWebskedStatus = (status) => {
    oldStatus = status
  }

  this.updateWebskedStatus = async (story) => {
    const storyWebskedStatus = story.workflow.status_code
    if (storyWebskedStatus !== oldStatus && story._id) {
      await this.setWebskedStatus(
        story._id,
        story.workflow.status_code,
        oldStatus,
        story.workflow.note
      )
    }
    oldStatus = storyWebskedStatus
  }

  this.setWebskedStatus = (storyId, newStatus, oldStatus, note) => {
    const data = {
      storyId: storyId,
      oldWorkflowStatus: oldStatus,
      newWorkflowStatus: newStatus,
      note: note,
    }

    const req = {
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      url: '/websked/api/tasks/workflowStatusChange',
      timeout: 100000,
    }
    return $http(req)
  }

  this.getWebskedStory = () => {
    const onStoryErr = (err) => console.log('could not get story', err)
    const onGetStory = (story) => {
      if (story && story._id) {
        return promiseWebsked(`stories?id=${story._id}`)
      } else {
        return $q.reject("Can't get websked data, no story/id found")
      }
    }
    // return storyService promise, with promise to return wsk story
    return storyService.getStory().then(onGetStory, onStoryErr)
  }

  this.getWebskedTasks = () => {
    const onStoryErr = (err) => console.log('could not get story', err)
    const onGetStory = (story) => {
      return promiseWebsked(`tasks?storyID=${story._id}`)
    }
    return storyService.getStory().then(onGetStory, onStoryErr)
  }

  // Plain static data, not available from any current WSK endpoint
  const priorities = {
    1: { name: intl.get('websked.priority.low'), uiClass: 'text-success' },
    2: { name: intl.get('websked.priority.medium'), uiClass: 'text-warning' },
    3: { name: intl.get('websked.priority.high'), uiClass: 'text-danger' },
  }

  let cfgPromise // runtime cache
  this.getWebSkedConfig = () => {
    // only get once, then return cached
    if (cfgPromise) {
      return cfgPromise
    }

    const getCfgPromises = [
      promiseWebsked('tasks/statuses'), // task statuses
      promiseWebsked('tasks/types'), // task types
      promiseWebsked('groups'), // groups
    ]

    // returns promise that resolves with single cfg object
    cfgPromise = Promise.all(getCfgPromises).then((vals) => ({
      // return obj
      taskStatuses: $fn.keyBy('id')(vals[0].data),
      taskTypes: $fn.keyBy('id')(vals[1].data),
      groups: $fn.keyBy('id')(vals[2].data),
      priorities, // static
    }))

    return cfgPromise
  }
}

export default ['$http', '$q', 'storyService', 'fnService', websked]
